import React, { useState, useEffect } from "react";

import { useProfile } from "app/context";
import useLatestMedia from "app/hooks/useLatestMedia";

import VideoStudioContext from "components/stories/video-studio/contexts/VideoStudioContext";

interface VideoPreviewProps {
  story: any;
  mediaVersion: any;
  onLoaded?: () => void;
  onPauseVideo: (pausedVideo?: boolean) => void;
  pausedVideo: boolean;
}

const VideoPreview: React.FC<VideoPreviewProps> = ({
  story, mediaVersion, onLoaded = undefined, onPauseVideo, pausedVideo
}) => {
  const { profile } = useProfile();

  const [isMounted, setIsMounted] = useState(true);
  const {
    isFetching: mediaIsFetching,
    thirdPartyMedias
  } = useLatestMedia(story, profile);

  useEffect(() => {
    setIsMounted(false);
  }, [mediaVersion.thirdPartyRenderId]);

  useEffect(() => {
    if (!isMounted) setIsMounted(true);
  }, [isMounted]);

  /*
  useEffect(() => {
    // if (onLoaded && videoCreator?.renderer?.element) onLoaded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  */

  if (!isMounted) return null;

  return (
    <VideoStudioContext
      playerCreatomateJson={mediaVersion.additionalData}
      mediaVersionHistory={thirdPartyMedias}
      mode="player"
      onPauseVideo={onPauseVideo}
      pausedVideo={pausedVideo}
      story={story}
      thirdPartyMediaIsFetching={mediaIsFetching}
    />
  );
};

export default VideoPreview;
